<template>
	<div class="subsection-population">
		<div class="subsection-population-cont">
			<div class="sub-popu-title">
				分段人数分布
			</div>
			<div style="display: flex;justify-content: center">
				<el-button size="mini" :class="{ 'tab-active': tabActive }" @click="buttonTabActive(true)">分数</el-button>
				<el-button size="mini" :class="{ 'tab-active': !tabActive }" @click="buttonTabActive(false)">比例</el-button>
			</div>
			<div class="sub-popu-show">
				<div class="sub-popu-title">
					<div>
						<p>您查看的科目为</p>
						<el-select v-model="curSubject" size="mini" placeholder="请选择" @change="selectSubject">
							<el-option v-for="item in basicInfo.examSubjectList" :key="item.pkId" :label="item.subName" :value="item.pkId">
								{{ item.subName }}
							</el-option>
						</el-select>
						<p>本科满分为 {{ basicInfo.examFullScore }} 分。</p>
						<p v-if="tabActive">
							<el-select v-model="basicInfo.scoreSegment" placeholder="请选择" size="mini" @change="changeSegment">
								<el-option v-for="(item, index) in basicInfo.scoreSegmentList" :key="index" :label="item" :value="item"> </el-option>
							</el-select>
							分为一个分数段，查看不同分数段的人数分布及详情。
						</p>
					</div>
					<div class="select-class">
						<el-button type="info" size="mini" @click="openClassDialog">选择班级</el-button>
					</div>
				</div>
				<div class="echarts-wrap">
					<chartBar :xAxisData="xAxisData" :lengthData="lengthData" :seriesData="seriesData" :titleStyle="titleStyle"></chartBar>
				</div>
				<div class="subPopu-table-view">
					<div class="table-view-desc">各分数段详细人数 - {{ basicInfo.examSubjectName }}</div>
					<div class="subPopu-table">
						<tables :tableOptions="basicInfo.tableData"></tables>
					</div>
				</div>
				<el-dialog title="选择班级" :visible.sync="dialogVisible" width="70%">
					<el-row>
						<el-col :span="8">班级总数：{{ basicInfo.allClassData.length }}</el-col>
						<el-col :span="16">已选中班级：{{ classIds.length }}</el-col>
					</el-row>
					<p style="padding: 10px 0">提示： 为保证图表显示直观清晰，班级数量选择不能超过10个。</p>
					<el-row>
						<el-checkbox-group v-model="classIds" @change="selectClass">
							<el-col :span="8" v-for="item in basicInfo.allClassData" :key="item.pkId" style="line-height: 25px">
								<el-checkbox :label="item.classCode">{{ item.className }}{{ item.classCode }}</el-checkbox>
							</el-col>
						</el-checkbox-group>
					</el-row>
					<span style="display: flex;justify-content: center;margin-top: 20px">
						<el-button @click="dialogVisible = false" size="medium">取 消</el-button>
						<el-button type="info" size="medium" @click="confirmDialog">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import chartBar from '../../../../../components/echarts/bar'
export default {
	components: {
		chartBar,
		tables: () => import('hm-table')
	},
	data() {
		return {
			dialogVisible: false,
			tabActive: true,
			curSubject: '0',
			classIds: [],
			basicInfo: {
				tableData: [],
				allClassData: [],
				examSubjectList: [],
				examSubjectName: '',
				examFullScore: '',
				scoreSegment: '',
				subjectId: '',
				scoreSegmentList: []
			},
			query: this.$route.query,
			xAxisData: [],
			lengthData: [],
			seriesData: [],
			titleStyle: {
				right: 10,
				top: -4,
				text: '',
				textStyle: {
					fontSize: 16
				}
			}
		}
	},
	mounted() {
		this.getScoreData(true)
	},
	methods: {
		// tab 切换
		buttonTabActive(val) {
			this.tabActive = val
			if (this.tabActive) {
				this.getScoreData()
			} else {
				this.rationSegment()
			}
		},
		//按比例
		rationSegment() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				subjectId: this.basicInfo.subjectId,
				classIds: this.classIds.join(',')
			}
			this.$post('reportApi/selectProporReport', params).then(res => {
				this.basicInfo.tableData = res.data.table
				this.tableToEcharts(res.data.table)
			})
		},

		//按分数  切换分数段
		changeSegment() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				subjectId: this.basicInfo.subjectId,
				cnA: 0,
				cnB: this.basicInfo.examFullScore,
				cnC: this.basicInfo.scoreSegment
			}

			this.$post('reportApi/setParameter', params).then(res => {
				if (res.code === '200') {
					this.getScoreData()
				}
			})
		},
		//按分数
		getScoreData(flag = false) {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: this.basicInfo.subjectId,
				classIds: this.classIds.join(',')
			}
			this.$post('reportApi/partReportSchool', params).then(res => {
				this.basicInfo = Object.assign({}, this.basicInfo, {
					tableData: res.data.table,
					allClassData: res.data.classNameAll,
					examSubjectList: res.data.examSubjectList,
					examFullScore: res.data.examSubjectScore,
					scoreSegment: res.data.scoreSegment
				})
				if (flag) {
					this.basicInfo.examSubjectName = res.data.examSubjectList[0].subName
					this.basicInfo.subjectId = res.data.examSubjectList[0].pkId
				}
				this.classIds = []
				let scoreSegmentList = [5]
				for (let i = 10; i <= this.basicInfo.examFullScore; i += 10) scoreSegmentList.push(i)
				this.basicInfo.scoreSegmentList = scoreSegmentList
				res.data.classNames.forEach(ele => this.classIds.push(ele.classCode))
				this.tableToEcharts(res.data.table)
			})
		},
		// table
		tableToEcharts(data) {
			let seriesData = {},
				xAxisData = [],
				lengthData = []
			for (let i = 0; i < data.length; i++) {
				for (let j = 0; j < data[i].length; j++) {
					if (j === 0) {
						seriesData[data[i][0].value] = {
							name: data[i][0].value,
							data: [],
							type: 'bar',
							barWidth: 12,
							itemStyle: { barBorderRadius: 12 }
						}
						if (i > 0) lengthData.push(data[i][0].value)
					} else {
						seriesData[data[i][0].value].data.push(data[i][j].value)
						if (i === 0) xAxisData.push(data[i][j].label)
					}
				}
			}
			this.seriesData = Object.values(seriesData).slice(1)
			this.xAxisData = xAxisData
			this.lengthData = lengthData
		},
		// 选择班级
		selectClass(val) {
			this.classIds = val
			if (this.classIds.length > 10) {
				this.classIds.pop()
				this.$message.error('最多只能选择10个')
			}
		},
		//选择班级 btn
		openClassDialog() {
			this.dialogVisible = true
		},
		// dialog确定 选定班级
		confirmDialog() {
			this.dialogVisible = false
			if (this.tabActive) {
				this.getScoreData()
			} else {
				this.rationSegment()
			}
		},
		// 选择科目
		selectSubject(val) {
			this.basicInfo.subjectId = val
			this.basicInfo.examSubjectName = this.basicInfo.examSubjectList.filter(res => val === res.pkId)[0].subName
			this.$forceUpdate()
			if (this.tabActive) {
				this.getScoreData()
			} else {
				this.rationSegment()
			}
		}
	}
}
</script>

<style lang="less" scoped>
.el-button--info {
	background-color: #009688;
	border-color: #009688;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #009688;
	border-color: #009688;
	color: #009688;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
	color: #009688;
}
/deep/.el-button:hover {
	background-color: #009688;
	border-color: #009688;
	color: white;
}
.subsection-population {
	height: auto;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.subsection-population-cont {
		height: auto;
		.sub-popu-title {
			margin-bottom: 10px;
			> span {
				font-weight: bold;
				font-size: 18px;
				color: #333;
				margin-right: 20px;
			}
		}
		.sub-popu-show {
			height: auto;
			.sub-popu-title {
				background-color: #fafafa;
				padding: 10px 20px;
				border-radius: 5px;
				display: flex;
				> div {
					display: flex;
					align-items: center;
					flex-grow: 1;
					> p {
						font-size: 14px;
					}
					/deep/.el-select,
					.el-input-number {
						width: 100.36px;
						margin: 0 5px;
					}
				}
				.select-class {
					display: flex;
					justify-content: flex-end;
				}
			}
			.sub-popu-canvas {
				height: 360px;
				margin: 10px 0;
				background-color: #fff;
			}
			.subPopu-table-view {
				height: auto;
				margin-top: 20px;
			}
			.table-view-desc {
				height: auto;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				margin-bottom: 5px;
				> p {
					text-align: left;
					-webkit-box-flex: 1;
					-ms-flex: 1;
					flex: 1;
					font-size: 14px;
					line-height: 40px;
				}
			}
			.subPopu-table {
				height: auto;
			}
		}
	}
	.tab-active {
		background: #1d635c;
		color: white;
	}
	.echarts-wrap {
		width: 100%;
		height: 500px;
	}
}
</style>
